<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{
              $vuetify.lang.translator("newPassword")
            }}</v-toolbar-title>
          </v-toolbar>
          <v-form ref="form" v-model="valid" @submit.prevent="tryReset">
            <v-card-text>
              <v-text-field
                :label="$vuetify.lang.translator('userName')"
                name="login"
                prepend-icon="fa-user"
                type="text"
                v-model="username"
                :rules="usernameRules"
                :placeholder="$vuetify.lang.translator('userNameExample')"
                clearable
                autocomplete="on"
                autofocus
                required
              />

              <v-text-field
                id="tac"
                :label="$vuetify.lang.translator('TAC')"
                name="tac"
                prepend-icon="fa-sms"
                type="text"
                v-model="tac"
                :rules="tacRules"
                clearable
                autocomplete="on"
                required
              />

              <v-text-field
                id="new-password"
                :label="$vuetify.lang.translator('newPassword')"
                name="new-password"
                prepend-icon="fa-lock"
                :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                v-model="newPassword"
                :rules="newPasswordRules"
                clearable
                autocomplete="on"
                required
              />

              <v-text-field
                id="confirm-password"
                :label="$vuetify.lang.translator('confirmNewPassword')"
                name="confirm-password"
                prepend-icon="fa-check-double"
                :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                v-model="confirmPassword"
                :rules="confirmPasswordRules"
                clearable
                autocomplete="on"
                required
              />
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    :label="$vuetify.lang.translator('securityCode')"
                    name="sc"
                    prepend-icon="fa-robot"
                    type="text"
                    v-model="captchaValue"
                    :rules="requiredRule"
                    clearable
                    autocomplete="on"
                  />
                </v-col>
                <v-col cols="6" md="4">
                  <v-img
                    max-height="50"
                    max-width="150"
                    :src="captchaImage"
                    :alt="$vuetify.lang.translator('securityCode')"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <br />
                  <audio controls v-if="captchaAudio">
                    <source :src="captchaAudio" type="audio/wav" />
                    Your browser does not support the audio element.
                  </audio>
                </v-col>
                <v-col cols="6" md="2" align-self="center" align="end">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        :loading="waitForCaptcha"
                        color="primary"
                        v-on="on"
                        @click="getSecurityCode()"
                      >
                        <v-icon class="mx-1">fa-sync-alt</v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      $vuetify.lang.translator("newSecurityCode")
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row>
                <v-col>
                  <v-btn
                    color="primary"
                    :disabled="loading"
                    :loading="loading"
                    type="submit"
                  >
                    <v-icon class="mx-1">fa-save</v-icon
                    >{{ $vuetify.lang.translator("save") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
            <v-card-actions>
              <v-row>
                <v-col>
                  <v-btn :to="{ name: 'SendTAC' }">
                    <v-icon class="mx-1">fa-sms</v-icon
                    >{{ $vuetify.lang.translator("doNotHaveTAC") }}
                  </v-btn>
                </v-col>
                <v-col
                  :class="
                    $store.getters.LANGUAGE == 'fa'
                      ? 'text-sm-left'
                      : 'text-sm-right'
                  "
                >
                  <v-btn :to="{ name: 'Login' }">
                    <v-icon class="mx-1">fa-sign-in-alt</v-icon
                    >{{ $vuetify.lang.translator("iHavePassword") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required, len, min, max, sameValue } from "@/helpers/validations";
import { handleError } from "@/helpers/helper";

export default {
  name: "ResetPassword",
  data: () => ({
    valid: false,
    loading: false,
    showPassword: false,
    username: "",
    tac: "",
    newPassword: "",
    confirmPassword: "",
    usernameRules: [],
    newPasswordRules: [],
    confirmPasswordRules: [],
    tacRules: [],
    requiredRule: [],
    waitForCaptcha: false,
    captchaImage: "",
    captchaAudio: "",
    captcha: 0,
    captchaValue: ""
  }),
  created() {
    this.username = this.$route.params.username;
    this.getSecurityCode();
  },
  methods: {
    getSecurityCode() {
      this.waitForCaptcha = true;
      this.captchaAudio = "";
      var self = this;
      this.$http
        .get("/captcha/" + this.captcha + "/")
        .then(function(response) {
          self.captcha = response.data.id;
          self.captchaImage =
            process.env.VUE_APP_URL +
            "/static/captcha/" +
            self.captcha +
            "/captcha.jpg";
          self.captchaAudio =
            process.env.VUE_APP_URL +
            "/static/captcha/" +
            self.captcha +
            "/captcha.wav";
        })
        .catch(function(error) {
          let result = handleError(
            error,
            self.$toasted,
            self.$router,
            self.$store
          );
          for (var item in result) {
            self.$toasted.error(result[item], {
              duration: 5000,
              keepOnHover: true,
              className:
                self.$store.getters.LANGUAGE == "fa"
                  ? "vazir-font-fd"
                  : "vazir-font",
              iconPack: "fontawesome",
              icon: "exclamation-triangle",
              position: "top-center"
            });
          }
        })
        .finally(() => {
          self.waitForCaptcha = false;
        });
    },
    tryReset() {
      this.usernameRules = [
        required(this.$vuetify.lang.translator("userName"), this.$vuetify),
        len(11, this.$vuetify.lang.translator("userName"), this.$vuetify)
      ];
      this.tacRules = [
        required(this.$vuetify.lang.translator("TAC"), this.$vuetify),
        len(6, this.$vuetify.lang.translator("TAC"), this.$vuetify)
      ];
      this.newPasswordRules = [
        required(this.$vuetify.lang.translator("password"), this.$vuetify),
        min(6, this.$vuetify.lang.translator("password"), this.$vuetify),
        max(30, this.$vuetify.lang.translator("password"), this.$vuetify)
      ];
      this.confirmPasswordRules = [
        required(
          this.$vuetify.lang.translator("confirmNewPassword"),
          this.$vuetify
        ),
        min(
          6,
          this.$vuetify.lang.translator("confirmNewPassword"),
          this.$vuetify
        ),
        max(
          30,
          this.$vuetify.lang.translator("confirmNewPassword"),
          this.$vuetify
        ),
        sameValue(
          this.$vuetify.lang.translator("newPassword"),
          this.$vuetify.lang.translator("confirmNewPassword"),
          this.newPassword,
          this.$vuetify
        )
      ];
      this.requiredRule = [
        required(this.$vuetify.lang.translator("securityCode"), this.$vuetify)
      ];
      let self = this;
      setTimeout(function() {
        if (self.$refs.form.validate()) {
          self.loading = true;
          self.$http
            .post("/auth/reset-password/", {
              mobile: self.username,
              password: self.newPassword,
              confirm_password: self.confirmPassword,
              sms_code: self.tac,
              captcha: self.captcha,
              captcha_value: self.captchaValue
            })
            .then(() => {
              self.$toasted.success(
                this.$vuetify.lang.translator("newPasswordSaved"),
                {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "check",
                  position: "top-center"
                }
              );
              self.$router.push({ name: "Login" });
            })
            .catch(error => {
              let result = handleError(
                error,
                self.$toasted,
                self.$router,
                self.$store
              );
              for (var item in result) {
                self.$toasted.error(result[item], {
                  duration: 5000,
                  keepOnHover: true,
                  className:
                    self.$store.getters.LANGUAGE == "fa"
                      ? "vazir-font-fd"
                      : "vazir-font",
                  iconPack: "fontawesome",
                  icon: "exclamation-triangle",
                  position: "top-center"
                });
              }
              self.getSecurityCode();
            })
            .finally(() => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>
